var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CommonFramework',{attrs:{"name":_vm.title}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }